var _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_3879",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 88,
    height: 88
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 88,
    height: 88,
    rx: 22,
    fill: "#FF965D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_3879)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "#E31D93"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.1112 41.8044C49.2276 40.7635 47.2251 39.9704 45.2424 39.1475C44.0924 38.6717 42.992 38.1165 42.0205 37.3433C40.1071 35.8166 40.4739 33.3382 42.7144 32.3567C43.3489 32.0792 44.0131 31.9899 44.6872 31.9503C47.2846 31.8115 49.7531 32.2873 52.1026 33.4175C53.2724 33.9826 53.659 33.8041 54.0556 32.5848C54.4719 31.296 54.8189 29.9874 55.2055 28.6887C55.4633 27.8163 55.1461 27.2413 54.3232 26.8745C52.8164 26.2103 51.2698 25.7345 49.644 25.4767C47.5225 25.1496 47.5225 25.1396 47.5126 23.0082C47.5027 20.0044 47.5027 20.0044 44.4889 20.0044C44.0527 20.0044 43.6165 19.9945 43.1804 20.0044C41.7726 20.0441 41.5347 20.2919 41.495 21.7095C41.4752 22.344 41.495 22.9785 41.4851 23.6229C41.4752 25.5064 41.4653 25.4767 39.661 26.131C35.299 27.7172 32.6025 30.6913 32.3151 35.4498C32.0573 39.6631 34.2581 42.5083 37.718 44.5802C39.8494 45.859 42.2088 46.6125 44.4691 47.6138C45.3514 48.0004 46.1941 48.4465 46.9277 49.0611C49.0988 50.8555 48.7022 53.8395 46.1247 54.9696C44.7467 55.5744 43.2894 55.7231 41.7924 55.5347C39.4826 55.2472 37.2719 54.6425 35.19 53.5619C33.9706 52.9274 33.6137 53.096 33.1974 54.4145C32.8405 55.5545 32.5232 56.7045 32.206 57.8545C31.7797 59.401 31.9383 59.7678 33.4155 60.4915C35.299 61.4036 37.3115 61.8695 39.3636 62.1966C40.9696 62.4544 41.0192 62.5238 41.039 64.1893C41.0489 64.9427 41.0489 65.7061 41.0588 66.4595C41.0688 67.4112 41.5248 67.9664 42.5062 67.9862C43.6165 68.006 44.7368 68.006 45.8471 67.9763C46.7592 67.9564 47.2251 67.4608 47.2251 66.5388C47.2251 65.5078 47.2747 64.4669 47.235 63.4358C47.1854 62.385 47.6415 61.8497 48.6527 61.5721C50.9823 60.9376 52.9651 59.6885 54.4918 57.8248C58.7348 52.6697 57.1189 45.1254 51.1112 41.8044Z",
    fill: "#E31D93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollar);
export default __webpack_public_path__ + "static/media/IconDollar.de7502e0bb65f761935939595d03a7b1.svg";
export { ForwardRef as ReactComponent };